(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/category/components/featured-game.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/category/components/featured-game.js');
"use strict";


const FeaturedGame = _ref => {
  let featuredGame = _ref.featuredGame;
  const InfoCard = svs.eInstant.components.InfoCard;
  const FeaturedGameDesktop = svs.eInstant.lobby.category.components.FeaturedGameDesktop;
  if (!featuredGame) {
    return null;
  }
  return svs.core.detect.formfactor.desktop() ? React.createElement(FeaturedGameDesktop, {
    featuredGame: featuredGame
  }) : React.createElement(InfoCard, {
    ticketConfig: featuredGame
  });
};
setGlobal('svs.eInstant.lobby.category.components.FeaturedGame', FeaturedGame);

 })(window);